import { useLocation, useNavigate } from 'react-router-dom'
import { formatRupees, pujaDateInfo } from '../services/pujaFormat.js'

/** Landing after verify-payment succeeds — `state.booking` is the confirmed
 * PujaBooking from the verify response. */
export default function PoojaBookingConfirmed() {
  const navigate = useNavigate()
  const state = useLocation().state ?? {}
  const booking = state.booking ?? null
  const mobile = state.mobile ?? ''
  const dateInfo = pujaDateInfo(booking?.puja_date)

  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-6 pt-28 pb-16 font-normal uppercase select-none">
      <div className="max-w-2xl w-full text-center space-y-8">
        {/* Diya icon on a soft amber halo */}
        <div className="relative mx-auto w-40 h-40">
          <div className="absolute inset-0 rounded-full bg-[radial-gradient(circle,rgba(242,160,7,0.18),transparent_70%)] blur-xl"></div>
          <div className="absolute inset-6 rounded-full bg-secondary/10"></div>
          <div className="absolute inset-0 grid place-items-center">
            <div className="w-16 h-16 rounded-full border-[3px] border-secondary grid place-items-center text-secondary bg-background">
              <i className="fa-solid fa-hands-praying text-2xl"></i>
            </div>
          </div>
        </div>

        <div className="space-y-4">
          <p className="text-[10px] font-mono font-normal text-secondary uppercase tracking-[0.5em]">
            SANKALP REGISTERED
          </p>
          <h1 className="font-heading text-4xl md:text-6xl text-primary font-normal uppercase leading-tight">
            POOJA BOOKING CONFIRMED
          </h1>

          {booking?.booking_number && (
            <div className="pt-2 flex items-center justify-center gap-3 flex-wrap">
              <span className="inline-flex items-center gap-3 px-6 py-2.5 rounded-full border border-secondary/40 bg-secondary/10">
                <span className="h-1.5 w-1.5 rounded-full bg-secondary animate-pulse"></span>
                <span className="text-[10px] font-mono font-normal text-primary/50 uppercase tracking-[0.25em]">BOOKING ID</span>
                <span className="text-sm font-mono font-semibold text-secondary tracking-widest">#{booking.booking_number}</span>
              </span>
              {booking.invoice_number && (
                <span className="inline-flex items-center gap-3 px-6 py-2.5 rounded-full border border-primary/15 bg-primary/5">
                  <span className="text-[10px] font-mono font-normal text-primary/50 uppercase tracking-[0.25em]">INVOICE</span>
                  <span className="text-xs font-mono font-semibold text-primary/70 tracking-widest">{booking.invoice_number}</span>
                </span>
              )}
            </div>
          )}

          <p className="mx-auto max-w-md text-base md:text-lg text-primary/70 font-body normal-case leading-relaxed">
            {booking?.puja?.title ? (
              <>Your sankalp for <span className="text-primary font-semibold">{booking.puja.title}</span> has been sent to the temple.</>
            ) : (
              'Your sankalp has been sent to the temple.'
            )}
            {dateInfo.label ? ` The ritual will be performed on ${dateInfo.weekday}, ${dateInfo.label}.` : ''}
            {booking?.final_amount != null ? ` Amount paid: ${formatRupees(booking.final_amount)}.` : ''}
          </p>

          <p className="mx-auto max-w-md text-xs text-primary/50 font-body normal-case leading-relaxed">
            <i className="fa-brands fa-whatsapp text-green-600 mr-1.5"></i>
            The confirmation email is on its way; pooja video and live updates will arrive on
            {mobile ? <span className="font-semibold text-primary/70"> +91 {mobile}</span> : ' your registered number'}.
          </p>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 pt-2">
          <button
            type="button"
            onClick={() => navigate('/pooja-energization')}
            className="group inline-flex items-center justify-center gap-3 h-14 px-10 rounded-lg bg-primary text-white hover:bg-secondary transition-all duration-300 font-semibold uppercase tracking-[0.2em] text-[11px] shadow-lg shadow-primary/20 active:scale-95"
          >
            BOOK ANOTHER POOJA
            <svg className="w-4 h-4 transition-transform group-hover:translate-x-1" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14" /><path d="m12 5 7 7-7 7" /></svg>
          </button>
          <button
            type="button"
            onClick={() => navigate('/products')}
            className="inline-flex items-center justify-center h-14 px-10 rounded-lg border border-primary/25 text-primary hover:border-secondary hover:text-secondary transition-all duration-300 font-semibold uppercase tracking-[0.2em] text-[11px] active:scale-95"
          >
            EXPLORE DIVINE SHOP
          </button>
        </div>
      </div>
    </div>
  )
}
